import React from 'react';
import s from "./Contacts.module.css";
import bg from "../../../assets/img/contacts_bg.jpg"
import ContactUsForm from "../../../components/ContactUsForm/ContactUsForm";

const Contacts = () => {
    return (
        <div className={s.wrapper}>
            <div className={s.container}>
                <div className={s.form_wrapper}>
                    <div className={s.title}>
                        Contact Us
                    </div>
                    <ContactUsForm/>
                </div>
                <div className={s.bg}>
                    <img src={bg} alt=""/>
                </div>
            </div>

        </div>
    );
};

export default Contacts;
